export var FormUrlType;
(function(FormUrlType) {
    FormUrlType["CollectResponses"] = "CollectResponses";
    FormUrlType["EditForm"] = "EditForm";
    FormUrlType["ViewResponses"] = "ViewResponses";
})(FormUrlType || (FormUrlType = {}));
